import type { EnsureOptions } from '../lists/interfaces'
import type { Options } from '@brighterly/lib-core-types/options/interfaces'
import type { OptionsStore } from './interfaces'

import { useOptionsApi } from './options-api.hook'

export const actions = {
  setOptions (this: OptionsStore, options: OptionsStore['options']): void {
    this.options = options
  },

  setCurrentTime (this: OptionsStore, payload: Pick<Options, 'current_time' | 'current_time_utc'>): void {
    if (!this.options) return
    this.options.current_time = payload.current_time
    this.options.current_time_utc = payload.current_time_utc
  },

  async ensure (this: OptionsStore, config: EnsureOptions = {}): Promise<OptionsStore['options']> { // FIXME: works incorrectly. Need fix
    if (!config.force && this.options) {
      return this.options
    }

    if (this.options && config.background) {
      void useOptionsApi()

      return this.options
    }

    return await useOptionsApi()
  },

  clear (this: OptionsStore): void {
    this.options = null
  },
}
